import React, { useRef } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import { _ } from '../../functions/translator.js';
import { GoChecklist } from "react-icons/go";
import { CircularProgress } from '@material-ui/core'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { postDataBlob } from '../../functions/postData.js';
import { CardsGroupStatus } from '../../constants/constants.js';

function ExportWeightingsButton(){
    const { selectedCardsGroups, projectData } = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
        projectData: state.projectData,
    }))
    const [showLoading, setShowLoading] = useState(false);
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);

    const buttonRef = useRef(null);

    const handleSubmit = async () => {
        setShowLoading(true)
        try {
            const filteredCardsGroupIds = selectedCardsGroups.filter(cardsGroupId => {
                const cardsGroupData = projectData?.cards_groups?.[cardsGroupId];
                return cardsGroupData?.attributes?.appartment_id && cardsGroupData?.attributes?.status !== CardsGroupStatus.STAND_BY;
            });

            let urlPost = {
                project_id: window.project_id,
                cards_group_ids: filteredCardsGroupIds,
            }
            const response = await postDataBlob('/export-weightings', urlPost, 'Error en la solicitud')
            const failureResponse = response.status === 'fail'
            
            if (!failureResponse) {
                const urlBlob = window.URL.createObjectURL(response)
                const link = document.createElement('a');
                link.href = urlBlob;
                link.download = 'ponderaciones.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setShowSuccessToast(true)
            } else {
                setShowFailureToast(true)
            }

        } catch (error) {
            console.error('Error:', error);
            setShowFailureToast(true)
        } finally {
            setShowLoading(false)
        }
    };

    return(
        <>
            {createPortal(
                <Snackbar 
                    onClose={() => setShowSuccessToast(false)} 
                    open={showSuccessToast} 
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    style={{ zIndex: 9999 }}
                >
                    <MuiAlert elevation={6} variant="filled" severity="success">
                        <p className='text-center w-100 m-0'>
                            ¡{_('Se han exportado Ponderaciones correctamente')}!
                        </p>
                    </MuiAlert>
                </Snackbar>,
                document.body
            )}
            {createPortal(
                <Snackbar 
                    onClose={() => setShowFailureToast(false)} 
                    open={showFailureToast} 
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    style={{ zIndex: 9999 }}
                >
                    <MuiAlert elevation={6} variant="filled" severity="error">
                        <p className='text-center w-100 m-0'>
                            ¡{_('Ha ocurrido un error al exportar')} {_('Ponderaciones')}!
                        </p>
                    </MuiAlert>
                </Snackbar>,
                document.body
            )}
            <div className="popup-menu-button card-color" ref={buttonRef} >
                <div className='w-100' onClick={handleSubmit}>
                    <div className='w-100 mt-1 d-inline-flex d-flex flex-row align-items-center justify-content-between'>
                        <div style={{width:'25px', height:'100%', position:'relative', left:'10px', marginRight:'2.5px', marginLeft:'2.5px'}}>
                            <GoChecklist size={30}/>
                        </div>
                        <div className='w-100 d-flex justify-content-center align-items-center'>
                            <div className='d-flex flex-column justify-content-center'>
                                <p className='m-0 text-center'>{ _('Exportar Resumen') }</p>
                                <p className='m-0 text-center'>{ _('por Departamento') }</p>
                            </div>
                            {showLoading && 
                                <div style={{ position: 'absolute', right: '10px', top: '20%' }}>
                                    <CircularProgress style={{ width:'20px', height:'20px' }} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExportWeightingsButton